import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

import { Face } from '../types';

interface AttendeeStore {
  face: Face | null;
  bearerToken: string;
  attendeeEmail: string | null;
  attendeeName: string | null;
  setBearerToken: (bearerToken: string) => void;
  setFace: (face: Face) => void;
  setAttendeeDetails: (details: {
    attendeeEmail?: string;
    attendeeName?: string;
  }) => void;
}

export const useAttendeeStore = create<AttendeeStore>()(
  subscribeWithSelector((set) => ({
    face: null,
    bearerToken: '',
    attendeeEmail: null,
    attendeeName: null,

    setBearerToken: (bearerToken) => set({ bearerToken }),
    setFace: (face) => set({ face }),
    setAttendeeDetails: ({ attendeeEmail, attendeeName }) => {
      set(() => ({
        ...(attendeeEmail !== undefined && { attendeeEmail }),
        ...(attendeeName !== undefined && { attendeeName }),
      }));
    },
  })),
);
